import { demandeToLocation } from '@/features/application/locations'
import { TRANSITION_CANCELED } from '@/features/domaine/machine-etats'
import { useDialog } from '@/features/interface/dialog'
import * as api from '@/features/services/demande'
import { SilentError } from '@/features/shared/types'
import {
  navigateTo,
  type NavigateToDemande,
  type NavigateToDemandeExtranet,
} from '@/router/navigateTo'
import type { CloneDemandeLaunch } from '../../demande/ajouter/CreationDemandeConfigurations'
import { useFavorisStore } from '../../favoris/favorisStore'
import { useRechercheDemandeTTStore } from './useRechercheDemandeTTStore.ts'
import { useAjouteDemandeTT } from '@/features/interface/demande/ajouter-tt'
import type { DemandeCreateResultDTO } from '@/features/api/extranet/dto/Demande/shared'

export function useRechercheDemandeTTActions() {
  const storeDemande = useRechercheDemandeTTStore()
  const storeAddDemande = useAjouteDemandeTT()
  const { addFavori } = useFavorisStore()

  const dialog = useDialog()

  const ouvrirDemande = (location: { sousDispositif: string | null, id: number }) =>
    navigateTo({
      to: 'detail',
      domaine: 'tt',
      module: 'demande',
      dispositif: 'fpe',
      sousDispositif: location.sousDispositif,
      id: location.id,
    } as NavigateToDemande)

  async function addDemande() {
    try {
      const demande = (await storeAddDemande.showAjoute()) as Required<DemandeCreateResultDTO>
      await ouvrirDemande(demande)
    } catch (err) {
      if (err !== TRANSITION_CANCELED) throw err
      console.error(err)
    }
  }

  async function deleteDemande(id: number) {
    const result = await dialog.showDialog({
      message: 'Confirmez-vous la suppression du brouillon ?',
      type: 'YesNo',
      title: 'Supprimer un brouillon',
    })
    if (result === 'Yes') {
      const location = demandeToLocation({
        typeDemande: 'SpecifiqueTT',
        dispositif: 'FPE',
        id: id,
      }) as NavigateToDemandeExtranet
      await api.demandeService.deleteDemande(location)
      await storeDemande.reloadData()
    }
  }

  async function cloneDemande(options: CloneDemandeLaunch) {
    try {
      const demande = await storeAddDemande.showClone(options) as Required<DemandeCreateResultDTO>
      await ouvrirDemande(demande)
    } catch (err) {
      if (err === TRANSITION_CANCELED) return
      if (err instanceof SilentError) return
      console.error(err)
    }
  }

  return { ouvrirDemande, deleteDemande, cloneDemande, addFavori, addDemande }
}
